import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "hidden sm:flex flex-wrap w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row gap-[20px] w-full mt-9" }, null, -1)
const _hoisted_3 = { class: "sm:hidden flex flex-col px-4 sm:flex-row gap-[20px] w-full mt-9" }
const _hoisted_4 = { class: "h-[235px] overflow-hidden sm:h-full sm:basis-1/2 sm:w-[calc(50%_-_10px)]" }
const _hoisted_5 = { class: "h-[235px] overflow-hidden sm:h-full sm:basis-1/2 sm:w-[calc(50%_-_10px)]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_SwiperSquareItem = _resolveComponent("SwiperSquareItem")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Title, {
      title: _ctx.title,
      subTitle: _ctx.subTitle
    }, null, 8, ["title", "subTitle"]),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dividedData, (group, groupIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: groupIndex,
          class: "w-[calc(50%_-_10px)] p-2"
        }, [
          _createVNode(_component_SwiperSquareItem, {
            height: '404px',
            customClass: 'g-swiper-square-item-type3',
            imageType: 'ads',
            selectItem: group
          }, null, 8, ["selectItem"])
        ]))
      }), 128)),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_SwiperSquareItem, {
          height: '235px',
          customClass: 'g-swiper-square-item-type3'
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_SwiperSquareItem, {
          height: '235px',
          customClass: 'g-swiper-square-item-type3'
        })
      ])
    ])
  ]))
}